import { createApp, h } from 'vue'
import store from './store'
import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config' 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import '../public/assets/css/style.css';
import '../public/assets/css/fonts.css';
import '../public/assets/css/customform.css';
import MultiSelect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css';
import useToast from 'vue-toast-notification';
import '../public/assets/css/calendar.css';
import '../public/assets/css/datatable.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import '../public/assets/css/sidebars.css';
import '../public/assets/css/login.css';
import 'primeicons/primeicons.css';
import globalVar from "@/globalVariables";
import Header from "./components/Header.vue";
import VueNumberFormat from 'vue-number-format';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Checkbox from 'primevue/checkbox';
import InputSwitch from 'primevue/inputswitch';
import Calendar from 'primevue/calendar';
import Divider from 'primevue/divider';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import FileUpload from 'primevue/fileupload';
import ProgressBar from 'primevue/progressbar';
import Chart from 'primevue/chart';
import Editor from 'primevue/editor';
import OverlayPanel from 'primevue/overlaypanel';
import Listbox from 'primevue/listbox';
import Tree from 'primevue/tree';
import AutoComplete from 'primevue/autocomplete';
import PanCardDesignComponent from './components/documents/PAN-card-design.vue';
import DrivingCardDesignComponent from './components/documents/Driving-card-design.vue';
import VoterCardDesignComponent from './components/documents/Voter-card-design.vue';
import AadhaarCardDesignComponent from './components/documents/Aadhaar-card-design.vue';

//const app = createApp(App)
const app = createApp({
    render () { return h(App); },
    provide: { globalVar },
});

app.component('TreeTable', TreeTable);
app.component('TriStateCheckbox', TriStateCheckbox);
app.component('Editor', Editor);
app.component('Button', Button);
app.component('Column', Column);
app.component('Dropdown', Dropdown);
app.component('Checkbox', Checkbox);
app.component('InputSwitch', InputSwitch);
app.component('Calendar', Calendar);
app.component('Divider', Divider);
app.component('FileUpload', FileUpload);
app.component('ProgressBar', ProgressBar);
app.component('OverlayPanel', OverlayPanel);
app.component('Listbox', Listbox);
app.component('Tree', Tree);
app.component("MultiSelect", MultiSelect);
app.component('DataTable', DataTable);
app.component('Chart', Chart);
app.component('Toast', useToast);
app.component('Header', Header);
app.component('AutoComplete', AutoComplete);
app.component('PanCardDesignComponent', PanCardDesignComponent);
app.component('DrivingCardDesignComponent', DrivingCardDesignComponent);
app.component('VoterCardDesignComponent',VoterCardDesignComponent);
app.component('AadhaarCardDesignComponent', AadhaarCardDesignComponent);

app.use(router)
app.use(PrimeVue)
app.use(VueNumberFormat)
app.use(store);
app.mount('#app')
app.config.devtools = true;

app.config.errorHandler = (err, vm, info) => {
    console.error("Error:", err);
    console.error("Vue component:", vm);
    console.error("Additional info:", info);
};